var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"columns is-marginless has-padding-50 has-padding-bottom-400 is-multiline"},[_c('div',{staticClass:"column is-12"},[_c('card',[_c('template',{slot:"header"},[_c('p',{staticClass:"card-header-title"},[_c('strong',[_vm._v("Promotions")])])]),_c('template',{slot:"body"},[_c('products-table')],1)],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }